import { withAIOpsDomainPrefix } from '@atlassian/aiops-common';
import { URLBuilder } from '@atlassian/eoc-alert-common';
import { fetch } from '@atlassian/eoc-fetch';

import { type AlertGroupFeatureStateResponse } from '../types';

export const getGroupFeatureStatus = (): Promise<AlertGroupFeatureStateResponse> => {
	const featureName = 'alert-grouping-web';
	const url = new URLBuilder(withAIOpsDomainPrefix('/v1/aiops/feature-state'))
		.withQueryParam('featureName', featureName)
		.build();
	return fetch<AlertGroupFeatureStateResponse>(url, {
		exactUrl: true,
	});
};
